export type MaterialMasterOption = {
  materialCode: string
  materialDesc: string
  customerCode: string
  skuInventoryStock: string
  purchaseOrderBased: string
}

export type MaterialSkuOption = {
  value: string
  /** Full searchable string (code + desc). */
  label: string
  code: string
  description: string
}

function normalizeMaterialRows(raw: unknown): Record<string, unknown>[] {
  if (!raw) return []
  if (Array.isArray(raw)) return raw as Record<string, unknown>[]
  return [raw as Record<string, unknown>]
}

/** Parse `/Fetch_MaterialDetails` — SAP CPI P4/I130 material master. */
export function parseMaterialDetailsResponse(data: unknown): MaterialMasterOption[] {
  const d = data as Record<string, unknown>
  const rd = (d.Response_Data ?? d.Response) as Record<string, unknown> | undefined
  const raw = rd?.item ?? rd?.Item
  const seen = new Set<string>()
  const out: MaterialMasterOption[] = []

  for (const row of normalizeMaterialRows(raw)) {
    const materialCode = String(row.Materials ?? row.Material ?? row.MaterialCode ?? '').trim()
    if (!materialCode || seen.has(materialCode)) continue
    seen.add(materialCode)
    out.push({
      materialCode,
      materialDesc: String(row.MaterialsDesc ?? row.MaterialDesc ?? row.Description ?? '').trim(),
      customerCode: String(row.CustomerCode ?? '').trim(),
      skuInventoryStock: String(row.SKUInventoryStock ?? '').trim(),
      purchaseOrderBased: String(row.PurchaseOrderBased ?? '').trim(),
    })
  }

  return out.sort((a, b) => a.materialCode.localeCompare(b.materialCode))
}

export function materialMasterDropdownOptions(
  materials: MaterialMasterOption[]
): MaterialSkuOption[] {
  return materials.map((m) => ({
    value: m.materialCode,
    code: m.materialCode,
    description: m.materialDesc,
    label: m.materialDesc ? `${m.materialCode} ${m.materialDesc}` : m.materialCode,
  }))
}
